export const initialValues = {
    id: null,
    immigration_id: '',
    company_id: '',
        company_value: '',
    employee_id: '',
        employee_code: '',
        employee_value: '',
    nationality_id: '',
        nationality_value: '',
    host_country_id: '',
        host_country_value: '',
    home_country_id: '',
        home_country_value: '',
    employer_entity: '',
    assignment_type_id: '',
        assignment_type_value: '',
    assignment_start_date: '',
    assignment_end_date: '',
    immigration_status_id: '',
        immigration_status_value: '',

    application_id: null,
    application_code: '',
    application_visa_type_id: '',
        application_visa_type_value: '',
    application_country_id: '',
        application_country_value: '',
    application_submission_date: '',
    application_status_id: '',
        application_status_value: '',
    application_start_date: '',
    application_expiry_date: '',
    application_duration: '',
    number_of_entries_id: '',
        number_of_entries_value: '',
    issuing_authority: '',
    reference_number: '',
    application_center: '',
    case_manager: '',
    assigned_team: '',
    client_contact: ''
};